<template>
  <div>
    <section
      class="add_new_head white--body tx--bege relative cover m_bg_blue"
      style="background-image:url('assets/img/layout/bg_serg.jpg');"
    >
      <div class="popup_close close-animate">
        <a @click="goBackRoute"><CloseSvg /></a>
      </div>
      <a class="no_mobile link_goback" @click="goBackRoute">
        חזרה <ArrowBack />
      </a>
      <div class="inner_width flex flex--column center">
        <h1 class="title">
          <span class="bold">יצירת ניתוח לשיבוץ -</span>{{ activeDoctor.name }}
        </h1>
        <Steps />
      </div>
    </section>
    <section class="add_new_main">
      <div class="add_st1" style="display:block">
        <div class="subtitle center">
          ליצירת ניתוח אנא הזינו תעודת זהות
        </div>
        <validation-observer ref="createAppForm">
          <form
            @submit.prevent="sendForm"
            v-promise-btn="{ action: 'submit' }"
            autocomplete="off"
          >
            <div class="w-570">
              <div class="form_input input-38">
                <label>ת.ז*</label>
                <validation-provider
                  :rules="{ required: true, israeliId: [isDarcon] }"
                  name="passport"
                  v-slot="{ errors }"
                >
                  <input
                    name="passport"
                    v-model="passport"
                    v-mask="isDarcon ? 'X'.repeat(100) : ['####', '#########']"
                    type="tel"
                    autocomplete="off"
                  />
                  <span class="error-message" v-if="errors.length > 0">
                    {{ errors[0] }}
                  </span>
                </validation-provider>
              </div>

              <div class="add_new_row flex desk-flex">
                <div class="form_check form_check-black">
                  <label>
                    <input type="checkbox" v-model="isDarcon" />
                    דרכון
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>

              <div
                class="form_submit center "
                :class="{ bt_disable: notValid }"
              >
                <button type="submit" class="bt_blue">הבא</button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import CloseSvg from "@/assets/img/svg/close.svg";
import ArrowBack from "@/assets/img/svg/arrow_r.svg";
import ErrorPopup from "@/components/Popups/Error";
import Steps from "@/components/Dashboard/Surgery/AddSurgery/Layout/Steps.vue";
import { getHash } from "@/utilities/hash.js";

const EMPTY_PATIENT = {
  apotropos: "",
  parental_status: "",
  birth_date: "",
  first_name: "",
  gender: "",
  last_name: "",
  phone: "",
  second_phone: "",
  status: "",
  email: ""
};

export default {
  name: "AddNewSurgery",
  components: {
    CloseSvg,
    ArrowBack,
    Steps
  },
  data() {
    return {
      isDarcon: false,
      passport: ""
    };
  },
  computed: {
    ...mapGetters(["activeDoctor", "doctors"]),
    notValid() {
      return !this.passport;
    },
    passportType() {
      return this.isDarcon ? "foreign" : "israeli";
    }
  },
  watch: {
    isDarcon() {
      this.passport = "";
    }
  },
  methods: {
    ...mapMutations("Surgery", ["SET_CURRENT_STEP", "RESET_STATE"]),
    ...mapActions(["SET_SURGERY_PATIENT"]),
    async sendForm() {
      const isValid = await this.$refs.createAppForm.validate();
      if (!isValid) {
        return;
      }

      try {
        const res = await this.$API.validatePassport(this.passport);

        if (res.status === "ERROR") {
          this.SET_SURGERY_PATIENT({
            ...EMPTY_PATIENT,
            id_num: this.passport,
            passport_type: this.passportType
          });
        } else {
          this.SET_SURGERY_PATIENT({
            ...res,
            passport_type: this.passportType
          });
        }

        const surgeryId = await this.$API.scheduleTempSurgery({
          doctor_id: this.activeDoctor?.id,
          passport: this.passport,
          passport_type: this.passportType
        });

        if (!surgeryId) {
          this.$modal.show(ErrorPopup, {
            title: "שגיאה ביצירת ניתוח, נסה שנית"
          });
          return;
        }

        this.SET_CURRENT_STEP(2);
        this.$router.push({ name: "surg-add-info" });
      } catch (error) {
        this.$modal.show(ErrorPopup, {
          title: error?.message || "שגיאה ביצירת ניתוח, נסה שנית"
        });
        throw error;
      }
    },
    goBackRoute() {
      const hashData = JSON.parse(localStorage.getItem("hashData"));
      if (!hashData || Object.keys(hashData).length === 0) {
        this.$router.push("/dashboard/surgeries");
        return;
      }

      const hash = getHash({});
      this.$router.push("/dashboard/surgeries#" + hash);
    }
  },
  mounted() {
    // Reset state on mount to ensure clean state for new surgery
    this.RESET_STATE();
  }
};
</script>
